export const capitalize = (s: string | null): string => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const stripTags = (t: string): string => t.replace(/(<([^>]+)>)/gi, '');
